import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MandantEdit } from '@entity/mandant';
import { MandantService } from '@service/mandant.service';

export const MandantResolve: ResolveFn<MandantEdit> = (route) => {
  return inject(MandantService).getMandant(route.params.id);
};
